import React from 'react';
import { Radio as RadioOld } from '../RadioDeprecated';
import { Radio as RadioNew } from './Radio';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Radio(props: any) {
  if ((props.options && props.options.length > 0) || props.selectedOptionId || props.buttonStyle) {
    return <RadioOld {...props} />;
  }
  return <RadioNew {...props} />;
}
